import { useQuery } from '@tanstack/react-query';
import { apiFetch } from './client.ts';
import { queryDefaults } from './queries.ts';
import { useSession } from '../auth/session.tsx';
import type { ClientStanding } from './types.ts';

/**
 * A client's standing now: appointments, the powers held today, and the people
 * on the legal side of the case.
 *
 * Keyed under the client, so recording a court order — which invalidates
 * `['client', id]` — refreshes the authority it may have changed.
 */
export function useClientStanding(clientId: string) {
  const { getToken } = useSession();
  return useQuery({
    queryKey: ['client', clientId, 'standing'],
    queryFn: () => apiFetch<ClientStanding>(`/clients/${clientId}/standing`, getToken),
    ...queryDefaults,
  });
}
